import { ITailwindCss } from '../types';

export function genTwCss(twCss: ITailwindCss | undefined): string {
  if (twCss) {
    return Object.values(twCss).join(' ');
  }
  return '';
}
